<div class="new-curso-container">
    <form [formGroup]="editCursoForm" (ngSubmit)="editCurso(editCursoForm.value)">
        <mat-form-field>
            <mat-label>Titulo</mat-label>
            <input matInput placeholder="titulo del curso" formControlName="titulo">
        </mat-form-field>

        <mat-form-field>
            <mat-label>Contenido</mat-label>
            <textarea matInput name="comentarios" rows="10" cols="40" formControlName="content">Escribe aquí tus comentarios</textarea>
           
            
        </mat-form-field>

        <mat-form-field>
            <mat-select placeholder="tags" formControlName="tags">
            
                <mat-option value="nota">NOTA</mat-option>
                <mat-option value="bricolaje">BRICOLAGE</mat-option>
               
            </mat-select>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Creador y fecha</mat-label>
            <input matInput placeholder="creador y fecha de la nota (ej: Fulano 15/5/20)" formControlName="creador">
        </mat-form-field>

        <div class="container-input-file">
            <label class="custom-file">
                <input type="file" formControlName="imagen" (change)="handleArchivo($event)">
                <mat-icon>cloud_upload</mat-icon><span>Subir archivo</span>
            </label>
        </div>


        <div class="container-button">
            <input type="submit" class="mat-flat-button" value="Guardar" [mat-dialog-close]="true">
        </div>

    </form>
</div>